import {
  userInfor,
  userLogin,
  userRegister,
  userRemoveFromCart
} from '../../api/api'
import axiosBase from '../../services/axios-base'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AppDispatch } from '../../store'
import { AxiosResponse } from 'axios'

export const checkRegisterUser =
  (registerForm: unknown) => async (dispatch: AppDispatch) => {
    try {
      const data = await userRegister(registerForm)

      localStorage.setItem('token', data.data)
      axiosBase.setToken(localStorage.token)

      dispatch({
        type: 'USER_LOGIN_AUTH',
        payload: {
          user: null,
          isAuthenticated: true,
          err: null
        }
      })
      window.location.href = '/'
    } catch (error) {
      localStorage.removeItem('token')
      axiosBase.setToken()
      dispatch({
        type: 'USER_LOGIN_AUTH',
        payload: {
          user: null,
          isAuthenticated: false,
          err: error
        }
      })
    }
  }

export const checkLogoutUser = () => (dispatch: AppDispatch) => {
  axiosBase.setToken()
  localStorage.removeItem('token')
  dispatch({
    type: 'USER_LOGOUT',
    payload: { user: null, isAuthenticated: false, err: null }
  })
  location.href = '/login'
}
export const loginAPI = createAsyncThunk(
  'user/login',
  async (inforLogin: { email: string; password: string }) => {
    const response = await userLogin(inforLogin)
    return response.data
  }
)

export const getInforUserAPI = createAsyncThunk('user/infor', async () => {
  axiosBase.setToken(localStorage.token)
  const response = await userInfor()
  return response.data
})

export const removeFromCartAPI = createAsyncThunk(
  'user/removeFromCart',
  async (productID: string, thunkAPI) => {
    const response: AxiosResponse<{ success: boolean; message: string }> =
      await userRemoveFromCart(productID)
    if (response.data.success) {
      thunkAPI.dispatch(getInforUserAPI())
    }
    return response.data
  }
)
